export const INTENT_CLASSIFY_FINE_TUNE_TYPE = 'intent_classify';
export const RAG_FINE_TUNE_TYPE = 'rag';